import { render, staticRenderFns } from "./highGoals.vue?vue&type=template&id=1c941ec5"
import script from "./highGoals.vue?vue&type=script&lang=js"
export * from "./highGoals.vue?vue&type=script&lang=js"
import style0 from "./highGoals.vue?vue&type=style&index=0&id=1c941ec5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports